<template>
  <div>
    <el-popover
        v-model="disabling"
        trigger="manual"
        placement="top"
        width="600">
      <div>
        <h4 style="text-align: center; margin: 10px 0px 20px 0px;">
          Disable Account
        </h4>
        <div>
          <label style="word-break: keep-all;">
            Are you sure you want to disable this account?
          </label>
        </div>
        <br>
        <div>
          <input
              id="unlink_devices"
              v-model="unlinkDevices"
              type="checkbox">
          <label
              style="word-break: keep-all;"
              for="unlink_devices">
            All client devices will be unlinked and all users will immediately lose access to the account.
          </label>
        </div>
      </div>
      <div style="text-align: center; padding: 20px">
        <el-button
            size="mini"
            type="text"
            plain
            @click="cancel">
          Cancel
        </el-button>
        <el-button
            size="mini"
            type="primary"
            :disabled="!unlinkDevices"
            @click="lock">
          Disable Account
        </el-button>
      </div>
      <div
          slot="reference"
          class="customer-field">
        <el-button
            v-if="enabled"
            :disabled="locking || disabling || enabling || !userHasPermission({permission: 'lock', on: 'Customer'})"
            class="custom-el-button"
            style="margin-bottom: 10px"
            size="small"
            type="primary"
            plain
            @click="change">
          Lock Account
        </el-button>
      </div>
    </el-popover>

    <el-popover
        v-model="enabling"
        trigger="manual"
        placement="top"
        width="600">
      <h4 style="text-align: center; margin: 10px 0px 20px 0px;">
        Enable Account
      </h4>
      <div>
        <label style="word-break: keep-all;">
          Are you sure you want to enable this account?
        </label>
      </div>
      <br>
      <div>
        <input
            id="verified_identity"
            v-model="accountVerfied"
            type="checkbox">
        <label
            style="word-break: keep-all;"
            for="verified_identity">
          I certify that I have gone through the appropriate steps to ensure this account's protection and deem it safe to enabled.
        </label>
      </div>
      <div style="text-align: center; padding: 20px">
        <span>
          <el-button
              size="mini"
              type="info"
              plain
              @click="cancel">
            Cancel
          </el-button>
        </span>
        <span>
          <el-button
              size="mini"
              type="primary"
              :disabled="!accountVerfied"
              @click="lock">
            Enable Account
          </el-button>
        </span>
      </div>
      <div
          slot="reference"
          class="customer-field">
        <el-button
            v-if="!enabled"
            :disabled="locking || disabling || enabling || !userHasPermission({permission: 'lock', on: 'Customer'})"
            style="margin-bottom: 10px"
            size="small"
            type="primary"
            plain
            @click="change">
          Unlock Account
        </el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import axios from "axios";
import { get } from "lodash";

import { EventBus } from "@/eventBus";

const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");
const { mapGetters: authGetters } = createNamespacedHelpers("auth");
const { mapGetters: sharedGetters } = createNamespacedHelpers("shared");

export default {
  name: "LockAccountButton",
  data() {
    return {
      enabled: false,
      locking: false,
      disabling: false,
      enabling: false,
      accountVerfied: false,
      unlinkDevices: false,
    };
  },
  computed: {
    ...accountGetters(["customer", "isLocked"]),
    ...authGetters(["user"]),
    ...sharedGetters(["userHasPermission"]),
  },
  mounted() {
    this.enabled = !this.isLocked;
  },
  methods: {
    cancel() {
      this.enabling = false;
      this.disabling = false;
      this.enabled = !this.isLocked;
    },
    change() {
      this.accountVerfied = false;
      this.unlinkDevices = false;
      if (this.isLocked) {
        this.enabling = true;
      } else {
        this.disabling = true;
      }
    },
    lock() {
      this.disabling = false;
      this.enabling = false;

      const url = this.isLocked
        ? `/v2/customers/${this.customer.id}/unlock`
        : `/v2/customers/${this.customer.id}/lock`;

      this.locking = true;
      axios
        .post(url)
        .then((response) => {
          const notifyMessage = this.isLocked
            ? "Account enabled successfully."
            : "Account disabled successfully.";
          this.$notify({
            title: this.isLocked ? "Enable Account" : "Disable Account",
            message: notifyMessage,
            type: "success",
          });

          this.$store.commit(
            "db/account/setSecurityStatus",
            get(response, "data.security_status", 1)
          );

          if (this.isLocked) EventBus.$emit("customer-account-locked");
          else EventBus.$emit("customer-account-unlocked");
        })
        .catch((error) => {
          this.$notify({
            title: this.isLocked ? "Enable Account" : "Disable Account",
            message: `Unable to complete the account ${
              this.isLocked ? "enabling" : "disabling"
            }`,
            type: "error",
          });
          this.enabled = !this.isLocked;
          console.error(error);
        })
        .finally(() => {
          this.enabled = !this.isLocked;
          this.locking = false;
        });
    },
  },
};
</script>
